// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import NavBar from './components/navbar';
import ProductDetail from './components/productdetail';
import Cartpage from './components/cartpage';
import CheckoutPage from './components/CheckoutPage';
import SuccessCard from './components/Success';
import NotFound404 from './components/PageNotFound';
import StyledDelivery from './components/StyledDelivery';
import SalesContainer from './components/SalesContainer';
import TrackOrderPage from './components/Tracker';
import Icon from './assets/icon.png';
import Footer from './components/footer';
import './styles/storefront.css';



import { CartProvider } from './context/CartContext';
import { FilterProvider } from "./context/FilterContext";

import './styles/home.css';
import './styles/SalesContainer.css';
import './styles/StyledDelivery.css';
import './styles/footer.css';

function App() {
  return (
    <CartProvider>
      <FilterProvider>
      <Router>
        <div>
          <a href="#main-content" className="skip-link">Skip to content</a>
          <NavBar />
          <div className="store-page" id="main-content" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<Cartpage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/success" element={<SuccessCard />} />
            <Route path="*" element={<NotFound404 />} />
            <Route path="/products" element={<SalesContainer />} />
            <Route path="/onsale" element={<StyledDelivery />} />
            <Route path="track" element={<TrackOrderPage />} />
            <Route path="/favicdon.ico" element={<img src={Icon} alt="favicon" style={{ display: 'none' }} />} />
          </Routes>
          </div>
          <Footer />
        </div>
      </Router>
      </FilterProvider>
    </CartProvider>
  );
}

export default App;
